<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <el-form-item>
        <el-select v-model="selected" @change="handleChange">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="default" icon="el-icon-search"></el-button>
      </el-form-item>
      <el-form-item class="page-panel-search-form-right-button">
        <el-button type="primary" @click="edit" v-if="contentView">编辑</el-button>
        <el-button type="primary" @click="upCompany" v-else>完成</el-button>
      </el-form-item>
    </el-form>
    <div v-if="contentView&&selected==1" class="video">
      <h3>{{briefData.companyName}}</h3>
      <div class="video_body">
        <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
          :options="playerOptions"></video-player>
      </div>
    </div>
    <!-- quill自带样式，如展示需在父级元素上加入 class='ql-editor' -->
    <div v-if="contentView&&selected===2">{{briefData.companyBody}}</div>
    <div v-if="!contentView&&selected===2">
      <el-input v-model="briefData.companyBody" placeholder="" type="textarea" rows="10"></el-input>
    </div>
    <div v-if="contentView&&selected===3" v-html="briefData.companyBody" class="ql-editor"></div>
    <div v-if="!contentView&&selected===3">
      <!-- <ueditor :config="editorConfig" v-model="briefData.companyBody"></ueditor> -->
      <!-- <qeditor style="margin-bottom: 3px;" :content.sync="briefData.companyBody"></qeditor> -->
      <editor v-model="briefData.companyBody" :min-height="192" />
    </div>
    <el-dialog title="更改视频地址" :visible.sync="dialogVisable" width="30%">
      <el-form ref="form" label-width="80px">
        <el-form-item label="视频地址">
          <el-input v-model="briefData.companyBody"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="upCompany">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import * as briefApi from '@/api/adminApi/zh/briefIntroduction';
export default {
  data() {
    return {
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      playerOptions: {
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [
          {
            type: '',
            // src: 'http://123.56.204.211:8001/file/1/v.m3u8'
            // type: ''
            src: ''
          }
        ],
        poster: '',
        width: document.documentElement.clientWidth
        // notSupportedMessage: '此视频暂无法播放，请稍后再试'
      },
      moveiPath: '',
      dialogVisable: false,
      options: [
        {
          value: 1,
          label: '简介视频'
        },
        {
          value: 2,
          label: '首页简版'
        },
        {
          value: 3,
          label: '简介介绍'
        }
      ],
      selected: 1,
      contentView: true,
      briefIntroduction: '',
      briefData: {}
    };
  },
  methods: {
    upCompany() {
      briefApi.upCompany(this.briefData).then(res => {
        if (this.selected === 1) {
          this.dialogVisable = false;
        } else {
          this.contentView = true;
        }
        this.getCompany();
      });
    },
    edit() {
      if (this.selected === 1) {
        this.dialogVisable = true;
      } else {
        this.contentView = false;
      }
    },
    handleChange() {
      this.briefData = {};
      this.contentView = true;
      this.getCompany();
    },
    getCompany() {
      briefApi.getCompany({ companyOrder: this.selected }).then(res => {
        this.briefData = res.data;
        if (this.selected === 1) {
          this.playerOptions.sources[0].src = this.briefData.companyBody;
        }
      });
    }
  },
  created() {
    this.getCompany();
  }
};
</script>
<style lang="stylus" scoped>
.video {
  h3 {
    text-align center
  }
  .video_body {
    width 80%
    margin 0 auto
    video {
      width 100%
    }
  }
}
.ql-editor {
  margin-bottom 40px
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/briefIntroduction/list.vue